import * as React from 'react';

import invariant from 'invariant';
import PropTypes from 'prop-types';
import { InjectedRouter } from 'react-router';

// @ts-ignore
import OrganizationActions from 'actions/OrganizationActions';
import ToastActions from 'actions/ToastActions';
// @ts-ignore
import { AdminRoles } from 'admin/constants/AdminRoles';
import CurrentUser from 'auth/CurrentUser';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import DialogContent from 'components/DialogContent';
import FormDeprecated from 'components/FormDeprecated';
// @ts-ignore
import FormInput from 'components/FormInput';
import LoadingIndicator from 'components/LoadingIndicator';
import apiRequest from 'lib/apiRequest';
// @ts-ignore
import RoleVerificationStore from 'stores/RoleVerificationStore';
// @ts-ignore
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';

import { InputChangeHandler } from 'types/typescript/eventHandlers';

import './styles/SetupSchoolEmail.scss';

export const libs = {
  apiRequest,
};

type Props = {
  router: InjectedRouter;
};

type State = {
  email: string;
  showEmailInput: boolean;
  enabled: boolean;
  submitting: boolean;
};
declare var window: { fbq: any };

class SetupSchoolEmail extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props: Props) {
    super(props);
    const initialEmail = CurrentUser.getUser().getEmail();

    this.state = {
      email: initialEmail,
      showEmailInput: !initialEmail,
      enabled: false,
      submitting: false,
    };
  }

  componentDidMount() {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'Lead');
    }
  }

  onSuccess = () => {
    OrganizationActions.loadUserOrganizations();
    UserActions.loadCurrentUser()
      .then(() => this.context.router.push({ pathname: '/classes' }))
      .catch(errorLogger('SetupSchoolEmail - can’t reload current user'));
  };
  onError = (error: any) => {
    this.setState({ submitting: false });
    ToastActions.showErrorToast(`Sorry, there was a problem: ${error.error}`);
  };
  onSubmit = () => {
    const roleVerification = RoleVerificationStore.getRoleVerification();
    invariant(roleVerification, 'missing roleVerification in SetupSchoolEmail.onSubmit');
    const orgId = roleVerification.organization_id;
    const officialTitle =
      roleVerification.role in AdminRoles
        ? AdminRoles[roleVerification.role]
        : roleVerification.role;
    const data = {
      official_email: this.state.email,
      official_title: officialTitle,
    };
    this.setState({ submitting: true });
    libs
      .apiRequest(
        `/organizations/${orgId}/users/${CurrentUser.getUser().id}/roles/admin`,
        'POST',
        data
      )
      .then(this.onSuccess, this.onError);
  };
  renderEmailConfirm = () => {
    if (this.state.submitting) {
      return <LoadingIndicator className="SetupSchoolEmail-loader" />;
    }
    return (
      <div className="SetupSchoolEmail-emailConfirm">
        <Button
          className="SetupSchoolEmail-emailConfirm-no"
          disabled={this.state.submitting}
          onClick={() => this.setState({ showEmailInput: true })}
          eventElementName="SetupSchoolEmail-emailConfirm-no">
          No
        </Button>
        <Button
          className="SetupSchoolEmail-emailConfirm-yes"
          disabled={this.state.submitting}
          onClick={this.onSubmit}
          eventElementName="SetupSchoolEmail-emailConfirm-yes">
          Yes
        </Button>
      </div>
    );
  };

  onChangeHandler: InputChangeHandler = event => {
    this.setState({ email: event.target.value });
  };
  renderEmailInput = () => {
    return (
      <BoxBody divided>
        <FormDeprecated
          onValid={() => this.setState({ enabled: true })}
          onInvalid={() => this.setState({ enabled: false })}
          onValidSubmit={this.onSubmit}>
          <div>
            <FormInput
              label="Email address"
              name="email"
              type="email"
              validations="isEmail"
              value={this.state.email}
              onChange={this.onChangeHandler}
            />
          </div>

          {this.state.submitting ? (
            <LoadingIndicator className="SetupSchoolEmail-loader" />
          ) : (
            <Button
              className="SetupSchoolEmail-emailConfirm-next"
              disabled={!this.state.enabled}
              type="submit"
              level="primary"
              eventElementName="SetupSchoolEmail-emailConfirm-next">
              Next
            </Button>
          )}
        </FormDeprecated>
      </BoxBody>
    );
  };
  render() {
    const roleVerification = RoleVerificationStore.getRoleVerification();
    if (!roleVerification) {
      this.context.router.push('/setup/admin_role');
      return null;
    }
    const orgType = roleVerification.is_school ? 'school' : 'district';
    const dialogTitle = this.state.showEmailInput
      ? `What is your official ${orgType} email address?`
      : `Is ${this.state.email} your official ${orgType} email address?`;
    return (
      <DialogContent size="small" className="SetupSchoolEmail" title={dialogTitle}>
        {this.state.showEmailInput ? this.renderEmailInput() : this.renderEmailConfirm()}
      </DialogContent>
    );
  }
}
export default SetupSchoolEmail;
